import { render, staticRenderFns } from "./WorkspaceLogoUpload.vue?vue&type=template&id=080dc2d2&scoped=true&"
import script from "./WorkspaceLogoUpload.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceLogoUpload.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceLogoUpload.vue?vue&type=style&index=0&id=080dc2d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080dc2d2",
  null
  
)

export default component.exports